import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "antd/dist/reset.css";
import "./i18n"; // Import i18n configuration
import { Spin } from "antd";
import { PostHogProvider } from "posthog-js/react";

// Loading component for suspense fallback
const Loader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <Spin size="large" />
  </div>
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Suspense fallback={<Loader />}>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: "https://eu.i.posthog.com",
        debug: import.meta.env.MODE === "development",
      }}
    >
      <App />
    </PostHogProvider>
  </Suspense>
);
